import { useQuery } from '@tanstack/react-query'
import { gameService } from '../../../../services/games/games'
import { setGraphClientAuthToken } from '../../../../services/graph-client'
import type { GetList } from '../../../../services/games/games/types'

export const GAMES_QUERY_KEY = ['getGames']

export const useGetGames = (
  params: GetList.Input,
  options?: { enabled?: boolean; token?: string | null },
) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [...GAMES_QUERY_KEY, params],
    enabled: options?.enabled ?? true,
    queryFn: () => {
      setGraphClientAuthToken(options?.token)

      return gameService.getList(params)
    },
  })

  return {
    games: data?.data,
    totalPages: data?.totalPages,
    isLoading,
    refetch,
  }
}
